import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {FlexCenterVertically} from '~/shared/theme/FlexLayout';

import {Cell} from './common';

const StyledChildHeadRow = styled(FlexCenterVertically)`
  justify-content: space-between;
  height: 24px;
  background: ${({theme}) => theme.colors.gray300};
  color: ${({theme}) => theme.colors.primaryText};
  padding: 0 34px;
  font-size: 14px;
  font-weight: 700;
`;

const ChildHeadRow = () => {
  const {t} = getLocalizationService();
  return (
    <StyledChildHeadRow>
      <FlexCenterVertically>
        <Cell width={120}>{t('time')}</Cell>
        <Cell width={300}>{t('business_name_2')}</Cell>
        <Cell width={110}>{t('order_type')}</Cell>
      </FlexCenterVertically>
    </StyledChildHeadRow>
  );
};

export default ChildHeadRow;
